import React, { useState, useEffect } from 'react'
import { Button, InputMasked } from '../../../ui'
import { useTranslation } from 'react-i18next'
import DataProvider from '../../../utils/provider'
import { MOBILE_VERIFICATION_CONFIRM } from '../../../constants/routes'
import { useStore } from '../../../StateProvider'
import styles from './style.css'

const CODE_LENGTH = 4

export const PhoneCodeVerification = ({ setIsCodeVerified }) => {
  const { t, i18n } = useTranslation()

  const [, dispatch] = useStore()

  const [code, setCode] = useState('')
  const [confirmError, setConfirmError] = useState('')
  const [confirmErrorI18n, setConfirmErrorI18n] = useState('')

  const isValidCode = code.length === CODE_LENGTH

  useEffect(() => {
    setConfirmErrorI18n(t(confirmError))
  }, [i18n.language, confirmError])

  /**
   * @param {React.ChangeEvent<HTMLInputElement>} param
   */
  const onChange = ({ target: { value } }) =>
    setCode(value)

  const confirmCode = () => {
    const resolve = ({ status }) => {
      if (status === 'INVALID_CODE') {
        setConfirmError('verifyPhone.codeInvalid')
      } else if (status === 'SUCCESS_VERIFICATION') {
        setIsCodeVerified()
        dispatch({
          type: 'setValidationFld',
          name: 'mobileVerification',
          value: true
        })
      } else {
        setConfirmError('verifyPhone.codeNotConfirmed')
      }
    }

    const reject = () => setConfirmError('verifyPhone.codeNotConfirmed')

    DataProvider.get(`${MOBILE_VERIFICATION_CONFIRM}?userCode=${code}`).then(resolve, reject)
  }

  /**
   * @param {boolean} isEnabled
   * @param {callback} callback
   */
  const handleKeyPress = (isEnabled, callback) =>
  /**
   * @param SyntheticKeyboardEvent<HTMLInputElement> param
   */
    ({
      charCode
    }) => {
      if (isEnabled && charCode === 13) {
        callback()
      }
    }

  return (
    <>
      <div className={styles.flexBlock}>
        <InputMasked
          type='string'
          value={code}
          label={t('verifyPhone.enterCode')}
          placeholder={t('verifyPhone.enterCode')}
          name='code'
          onChange={onChange}
          maxLength={4}
          valid={isValidCode}
          showLabelAsPlaceholder
          blockClassName={styles.enterCodeFld}
          mask={[/[1-9]/, /\d/, /\d/, /\d/]}
          guide={false}
          onKeyPress={handleKeyPress(isValidCode, confirmCode)}
        />
        <Button
          disabled={!isValidCode}
          onClick={confirmCode}
          className={styles.confirmButton}
          name='confirmCode'
        >
          {t('verifyPhone.confirm')}
        </Button>
      </div>
      <div className={styles.error}>{confirmErrorI18n}</div>
    </>
  )
}
